import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-60px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClass = "" }) => (
    <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
        <motion.span
            className={`block will-change-transform ${innerClass}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const Overline = ({ children, className = "" }) => (
    <p
        className={`text-[11px] sm:text-xs uppercase tracking-[0.35em] font-sans font-semibold text-saffron-bright/90 ${className}`}
    >
        {children}
    </p>
);

export const OrnamentDivider = ({ className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
        <span className="h-px w-10 sm:w-16 bg-gradient-to-r from-transparent to-brass/60" />
        <span className="text-brass text-xs tracking-widest">✦</span>
        <span className="h-px w-10 sm:w-16 bg-gradient-to-l from-transparent to-brass/60" />
    </div>
);
